import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

interface IEmployerProfileWrapperProps {
  isRecruiter?: boolean;
}

export const EmployerProfileWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.pageBackground};
  padding: ${(props: IEmployerProfileWrapperProps) =>
    props.isRecruiter ? "105px 0 0 60px" : "57px 0 0 60px"};
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${mediaMaxWidth.tablet} {
    padding: ${(props: IEmployerProfileWrapperProps) =>
      props.isRecruiter ? "49px 0 0 0" : "57px 0 0 0"};
  }
`;

interface IProfileDataProps {
  isRecruiter?: boolean;
  noSlides?: boolean;
}

export const ProfileData = styled.div`
  position: relative;
  top: ${(props: IProfileDataProps) =>
    props.isRecruiter && props.noSlides ? "10px" : "-50px"};
  top: ${(props: IProfileDataProps) =>
    !props.isRecruiter && props.noSlides && "10px"};
  padding-bottom: 10px;
  display: flex;
  justify-content: center;

  ${mediaMaxWidth.tablet} {
    margin-left: 0;
  }
`;
